import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Brands() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="brands" className="py-32 bg-[#0D0D0D] relative overflow-hidden">
      {/* Subtle texture lines */}
      <div className="absolute inset-0 pointer-events-none opacity-30">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />
        <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold/30 to-transparent" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <div
          ref={ref}
          className={`transition-all duration-1000 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          {/* Section Header */}
          <div className="text-center mb-16">
            <span className="text-gold text-[10px] font-semibold tracking-[0.35em] uppercase mb-5 block">
              Sister Brand
            </span>
            <h2 className="font-heading text-4xl md:text-5xl font-light text-white leading-tight">
              Beyond Trade
            </h2>
            <div className="flex justify-center mt-4">
              <div className="section-divider" />
            </div>
          </div>

          {/* Brand Card */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 border border-charcoal-border overflow-hidden">
            {/* Image */}
            <div className="relative h-72 lg:h-auto overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/ebe731143a9b74d7bf04e4494a145c6e.jpg"
                alt="Abumi Paws and Co"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent to-[#0D0D0D]/60" />
            </div>

            {/* Content */}
            <div className="p-12 lg:p-16 flex flex-col justify-center bg-charcoal-light">
              {/* Brand badge */}
              <div className="inline-flex items-center gap-2 mb-6 self-start border border-gold/30 px-4 py-2">
                <i className="ri-footprint-line text-gold text-xs" />
                <span className="text-[10px] text-gold tracking-[0.2em] uppercase font-medium">Premium Pet Lifestyle</span>
              </div>

              <h3 className="font-heading text-3xl md:text-4xl text-white font-light mb-2">
                Abumi Paws &amp; Co.
              </h3>
              <p className="text-gold text-sm font-heading italic mb-6">
                Because they deserve the best
              </p>

              <div className="w-8 h-px bg-gold/40 mb-6" />

              <p className="text-[#7A7A7A] text-sm leading-relaxed tracking-wide mb-8">
                A premium pet lifestyle brand focused on comfort, care, and quality. Abumi Paws &amp; Co. brings the same dedication to quality and sourcing that defines ABUMI Trading — now channeled into thoughtfully designed products for the pets who matter most.
              </p>

              <div className="flex flex-wrap gap-4">
                {['Premium Quality', 'Thoughtful Design', 'Comfort Focused'].map((tag) => (
                  <span
                    key={tag}
                    className="text-[10px] text-charcoal-text border border-charcoal-border px-4 py-1.5 tracking-wider"
                  >
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
